import { render, staticRenderFns } from "./JournalPage.vue?vue&type=template&id=4f666d4a"
import script from "./JournalPage.vue?vue&type=script&lang=js"
export * from "./JournalPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports